import { createRoot } from 'react-dom/client';

import { analytics, getRouteContextFromPathname } from './analytics';
import Root from './Root';
import { initializeDevTools } from './utils/devTools';
import { initializeAnalyticsTools } from './utils/initializeAnalyticsTools';

import '@/styles/base/base.scss';
import '@/styles/css-variables.scss';
import '@/styles/styles.scss';

// Initialize development tools
initializeDevTools();

analytics.setFallbackContextGetter(() =>
    getRouteContextFromPathname(window.location.pathname, window.location.search)
);

// Initialize analytics tools
initializeAnalyticsTools();

const container = document.getElementById('root');
if (!container) {
    throw new Error('index.html has no #root element to mount the app in');
}
createRoot(container).render(<Root />);
